import type { InboxEntry } from '@/lib/mentionsInbox';
import type { ResponseThreshold } from '@/lib/responseTime';
import { ENTITIES } from './model';
export const RESPONSE_POLICY: readonly ResponseThreshold[] = [
  { afterMs: 60 * 60_000, tone: 'warning', label: 'Больше часа' },
  { afterMs: 120 * 60_000, tone: 'danger', label: 'Больше двух часов' },
];
export const AGE_OPTIONS = [
  { value: 60 * 60_000, label: 'От 1 часа' },
  { value: 120 * 60_000, label: 'От 2 часов' },
  { value: 24 * 60 * 60_000, label: 'От 1 дня' },
];
export function makeInboxEntries(now: number): InboxEntry[] {
  const specs = [
    [
      'layout-a',
      'chat',
      'layout',
      'Общий макет',
      0,
      126,
      true,
      true,
      'Посмотри, пожалуйста, отступы в <#workshop>. Ждём твоего решения.',
    ],
    [
      'layout-b',
      'chat',
      'layout',
      'Общий макет',
      1,
      92,
      false,
      true,
      '<@anna>, добавила второй вариант. Можно выбрать одну из двух схем.',
    ],
    [
      'notes-a',
      'mail',
      'notes',
      'Заметки к встрече',
      2,
      47,
      true,
      true,
      'Подтверди, пожалуйста, что время встречи подходит. Повестка уже в письме.',
    ],
    [
      'notes-b',
      'mail',
      'notes',
      'Заметки к встрече',
      0,
      32,
      false,
      false,
      'Короткая встреча: сверим вопросы и договоримся о следующем шаге.',
    ],
    [
      'discussion-a',
      'forum',
      'layout',
      'Формулировки в макете',
      3,
      1565,
      false,
      false,
      'Нужен взгляд со стороны: какая подпись понятнее для нового участника?',
    ],
    [
      'files-a',
      'chat',
      'files',
      'Материалы для образца',
      1,
      -18,
      false,
      false,
      'Спасибо, все материалы собраны. Можно пользоваться вымышленным набором.',
    ],
    [
      'invite-a',
      'mail',
      'invite',
      'Приглашение на встречу',
      2,
      -8,
      true,
      false,
      'Встреча подтверждена. Запись и заметки добавим после обсуждения.',
    ],
    [
      'code-a',
      'forum',
      'code',
      'Пример кода в заметке',
      0,
      89,
      true,
      true,
      'Проверь, пожалуйста, *пример кода* и короткое пояснение к нему.',
    ],
  ] as const;
  const source = {
    chat: { label: 'Чат', channel: '#мастерская' },
    mail: { label: 'Почта', channel: 'Встреча команды' },
    forum: { label: 'Обсуждение', channel: 'Общий макет' },
  };
  return specs.map(([id, sourceId, threadId, subject, author, minutes, mine, unread, text], i) => ({
    id,
    sourceId,
    threadId,
    subject,
    mine,
    unread,
    message: {
      id: 'inbox-' + id,
      author: ENTITIES[author],
      sentAt: new Date(now - Math.abs(minutes) * 60_000 - i * 1000).toISOString(),
      source: source[sourceId],
      content: { format: 'chat', text },
      ...(minutes >= 0
        ? { response: { since: new Date(now - minutes * 60_000).toISOString(), thresholds: RESPONSE_POLICY } }
        : {}),
    },
  }));
}
